import { render, staticRenderFns } from "./editMoonSampleInfor.vue?vue&type=template&id=0f452804&scoped=true&"
import script from "./editMoonSampleInfor.vue?vue&type=script&lang=js&"
export * from "./editMoonSampleInfor.vue?vue&type=script&lang=js&"
import style0 from "./editMoonSampleInfor.vue?vue&type=style&index=0&id=0f452804&lang=scss&scoped=true&"
import style1 from "./editMoonSampleInfor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f452804",
  null
  
)

export default component.exports